const reasonsToDoBusiness = [
  // High Importance
  { reason: "Financial Independence", importance: 95, level: "High" },
  { reason: "Passion and Interest", importance: 90, level: "High" },
  { reason: "Entrepreneurial Spirit", importance: 85, level: "High" },
  { reason: "Creating Jobs and Impact", importance: 85, level: "High" },
  { reason: "Innovation and Creativity", importance: 85, level: "High" },
  { reason: "Making a Difference", importance: 90, level: "High" },
  { reason: "Financial Rewards", importance: 90, level: "High" },
  { reason: "Personal Growth and Learning", importance: 75, level: "High" },
  { reason: "Contributing to the Economy", importance: 75, level: "High" },
  { reason: "Diverse Opportunities", importance: 80, level: "High" },
  { reason: "Global Impact", importance: 85, level: "High" },

  // Moderate Importance
  { reason: "Flexibility and Control", importance: 80, level: "Moderate" },
  { reason: "Building a Legacy", importance: 80, level: "Moderate" },
  { reason: "Autonomy and Independence", importance: 70, level: "Moderate" },
  { reason: "Taking Control of Career", importance: 70, level: "Moderate" },
  { reason: "Market Penetration", importance: 70, level: "Moderate" },
  { reason: "Geographical Expansion", importance: 65, level: "Moderate" },
  {
    reason: "Brand Awareness and Recognition",
    importance: 65,
    level: "Moderate",
  },
  { reason: "Employee Growth", importance: 60, level: "Moderate" },
  { reason: "Product or Service Expansion", importance: 70, level: "Moderate" },
  {
    reason: "Employee Productivity and Efficiency",
    importance: 60,
    level: "Moderate",
  },

  // Low Importance
  { reason: "Prestige and Status", importance: 40, level: "Low" },
  { reason: "Social Recognition", importance: 45, level: "Low" },
  { reason: "Immediate Profit", importance: 40, level: "Low" },
  { reason: "Trend Following", importance: 35, level: "Low" },
  { reason: "Avoiding 9-to-5 Jobs", importance: 30, level: "Low" },
  { reason: "Competing with Others", importance: 40, level: "Low" },
  { reason: "Short-Term Gains", importance: 35, level: "Low" },
  { reason: "Being Your Own Boss", importance: 30, level: "Low" },
  { reason: "Overemphasis on Revenue", importance: 40, level: "Low" },
  { reason: "Avoiding Boredom", importance: 25, level: "Low" },
  { reason: "Replicating Others", importance: 30, level: "Low" },
  { reason: "Quick Fixes", importance: 35, level: "Low" },
  { reason: "Lack of Risk Tolerance", importance: 25, level: "Low" },
  { reason: "Status Quo Maintenance", importance: 30, level: "Low" },
  { reason: "Avoiding Authority", importance: 20, level: "Low" },
];

export default reasonsToDoBusiness;
